import { render, staticRenderFns } from "./SaisirPaiementPaysafe.vue?vue&type=template&id=10b0f293&scoped=true"
import script from "./SaisirPaiementPaysafe.vue?vue&type=script&lang=js"
export * from "./SaisirPaiementPaysafe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b0f293",
  null
  
)

export default component.exports